import { contractRequest } from "@/portals/physician/api/transport";

// Module 4 — a patient's assigned physician. patientId is the person_profiles id
// (works for dependents too). Failures go through the one contract error parser.

export interface AssignedPhysician {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  assignedAt: string;
}

export interface PatientPhysicianResponse {
  physician: AssignedPhysician | null;
}

const path = (patientId: string) => `/api/v1/admin/patients/${encodeURIComponent(patientId)}/physician`;

export const getPatientPhysicianApi = (patientId: string) =>
  contractRequest<PatientPhysicianResponse>(path(patientId), { method: "GET", portal: "admin" });

/** 404 PATIENT_NOT_FOUND · 404 PHYSICIAN_NOT_FOUND */
export const assignPatientPhysicianApi = (patientId: string, physicianUserId: string) =>
  contractRequest<PatientPhysicianResponse>(path(patientId), { method: "PUT", portal: "admin", body: { physicianUserId } });

export const removePatientPhysicianApi = (patientId: string) =>
  contractRequest<PatientPhysicianResponse>(path(patientId), { method: "DELETE", portal: "admin" });
